import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ContactComponent} from './core/containers/contact/contact.component';
import {DownloadComponent} from './core/containers/download/download.component';
import {ImprintComponent} from './core/components/content-pages/imprint/imprint.component';
import {PrivacyComponent} from './core/components/content-pages/privacy/privacy.component';
import {TacComponent} from './core/components/content-pages/tac/tac.component';
import {ContentPageComponent} from './core/containers/content-page/content-page.component';
import {AuthenticatedAuthGuardService} from './user/services/authenticated-auth-guard.service';

const routes: Routes = [
    {
        path: 'products',
        loadChildren: () => import('./products/products.module').then(m => m.LazyProductsModule),
        canActivate: [AuthenticatedAuthGuardService]
    },
    {
        path: 'home',
        loadChildren: () => import('./landing/landing.module').then(m => m.LazyCategoriesModule),
        canActivate: [AuthenticatedAuthGuardService]
    },
    {
        path: 'imprint',
        component: ContentPageComponent,
        data: {contentComponent: ImprintComponent},
    },
    {
        path: 'terms-and-conditions',
        component: ContentPageComponent,
        data: {contentComponent: TacComponent},
    },
    {
        path: 'privacy',
        component: ContentPageComponent,
        data: {contentComponent: PrivacyComponent},
    },
    {
        path: 'contact',
        component: ContactComponent,
        canActivate: [AuthenticatedAuthGuardService]
    },
    {
        path: 'download',
        component: DownloadComponent,
        canActivate: [AuthenticatedAuthGuardService]
    },
    {path: '', redirectTo: '/home', pathMatch: 'full'},
    {path: '**', redirectTo: '/home', pathMatch: 'full'}
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled', useHash: true, initialNavigation: 'enabled'})
    ],
    exports: [RouterModule],
})

export class AppRoutingModule {
}

// export const routedComponents = [NameComponent];
